module.exports = __webpack_public_path__ + "img/person.c3da2024.svg";